import token from 'styled-token';

/** @mixin mediaBreakpointMixin */
/**
 * Returns the media feature for the given breakpoint.
 *
 * @example
 * import { mediaBreakpointMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     @media ${mediaBreakpointMixin('md')} {
 *         color: red;
 *     }
 * `;
 *
 * <Component>This text will be red at the "md" breakpoint</Component>
 *
 * @method
 * @param {string} breakpoint - A breakpoint media token. By default, this will apply to sizes
 *     greater than or equal (gte) to the the breakpoint value. You can specify sizes
 *     less than or equal (lte), or exactly equal by appending to the breakpoint,
 *     e.g. sm_lte, md_eq, lg_gte.
 * @return {Interpolation}
 */
export var mediaBreakpointMixin = function mediaBreakpointMixin(breakpoint) {
  var split = breakpoint.split('_');
  var shirtSize = split[0];
  var strategy = split[1] || 'gte';
  return token('breakpoints', function (breakpoints) {
    if (!breakpoints) {
      return 'all';
    }
    var keys = Object.keys(breakpoints);
    var value = breakpoints[shirtSize];
    var index = keys.indexOf(shirtSize);
    if (index < 0) {
      throw new Error("The breakpoint size '" + shirtSize + "' does not exist on the theme. Use one of " + keys.map(function (k) {
        return "'" + k + "'";
      }).join(', ') + ".");
    }
    if (['lte', 'eq', 'gte'].indexOf(strategy) < 0) {
      throw new Error("The strategy '" + strategy + "' is not valid for breakpoint '" + breakpoint + "'. Use one of '" + shirtSize + "_lte', '" + shirtSize + "_eq', '" + shirtSize + "_gte'.");
    }
    var min = '';
    if (strategy !== 'lte') {
      min = "(min-width: " + value + "px)";
    }
    var max = '';
    if (strategy !== 'gte' && index < keys.length - 1) {
      max = "(max-width: " + (breakpoints[keys[index + 1]] - 1) + "px)";
    }
    if (min || max) {
      return "" + min + (min && max ? ' and ' : '') + max;
    }
    return 'all';
  });
};